import { useEffect, useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { PasswordField } from "./PasswordField";

// mode: "name" | "password"
export const EditDriverDialog = ({ driver, mode, onClose, onSubmit }) => {
  const [value, setValue] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setValue(mode === "name" ? driver?.name || "" : "");
    setError("");
  }, [driver, mode]);

  const valid = mode === "name" ? value.trim().length > 0 : value.length >= 8;

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const err = await onSubmit(value);
    setBusy(false);
    if (err) setError(err);
  };

  return (
    <Dialog open={!!driver} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-lg" data-testid={`${mode}-driver-dialog`}>
        <DialogHeader>
          <DialogTitle>{mode === "name" ? "Edit driver" : "Reset password"}</DialogTitle>
          <DialogDescription>{driver?.email}</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-4">
          {mode === "name" ? (
            <div>
              <Label htmlFor="edit-driver-name">Full name</Label>
              <Input id="edit-driver-name" className="mt-1.5 h-11" value={value} onChange={(e) => setValue(e.target.value)} data-testid="edit-driver-name-input" />
            </div>
          ) : (
            <PasswordField value={value} onChange={setValue} label="New password" />
          )}
          {error && <p className="text-sm text-rose-600" data-testid="edit-driver-error">{error}</p>}
          <DialogFooter className="gap-2 sm:gap-2">
            <Button type="button" variant="outline" onClick={onClose} data-testid="edit-driver-cancel-btn">Cancel</Button>
            <Button type="submit" disabled={!valid || busy} className="bg-[#002FA7] hover:bg-[#001A75]" data-testid="edit-driver-submit-btn">
              {busy ? "Saving…" : mode === "name" ? "Save" : "Set new password"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
